import { DataTable } from 'primereact/datatable';
import React, { useState, useEffect } from 'react';
import ExportButton from '../../../../component/export-button/export-button';
import { Column } from 'primereact/column';
import { DocDetails } from '../../../../api/types/docs/doc-details';
import { DocFeedbackStatusDB } from '../../../../api/types/docs/doc-feedback-status';
import dateUtils from '../../../../utils/date-format';
import { Dialog } from 'primereact/dialog';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { FaChevronDown } from 'react-icons/fa';
import { Tag } from 'primereact/tag';
import { DocFeedbackItem } from '../../../user-page/pages/docs/componenets/doc-feedback-item';
import { Button } from 'primereact/button';
import { AddNewDocFeedback } from '../../../user-page/pages/docs/componenets/add-new-doc-feedback';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';
import { updateDocFeedbackHomescreenOperation } from './operations/update-doc-feedback-homescreen-operation';

interface WaitingDocsProps {
  docs: DocDetails[];
  onUpdate: () => any;
}

const WaitingDocs: React.FC<WaitingDocsProps> = ({ docs, onUpdate }) => {
  const [selectedDoc, setSelectedDoc] = useState<DocDetails | null>(null);
  const [showFeedbackDialog, setShowFeedbackDialog] = useState(false);
  const [addFeedbackIndex, setAddFeedbackIndex] = useState<number | null>(null);
  const [localDocs, setLocalDocs] = useState<DocDetails[]>(docs);

  // Update local docs when props change
  useEffect(() => {
    setLocalDocs(docs);
  }, [docs]);

  // Filter documents to show only those with last feedback as pending (Init) or rejected (Reject)
  const waitingDocs = localDocs.filter((doc) => {
    if (doc.feedbacks.length === 0) {
      return true; // No feedback means it's waiting
    }
    const lastFeedback = doc.feedbacks[doc.feedbacks.length - 1];
    return (
      lastFeedback.status === DocFeedbackStatusDB.Init ||
      lastFeedback.status === DocFeedbackStatusDB.Reject
    );
  });

  const getTag = (status: DocFeedbackStatusDB) => {
    switch (status) {
      case DocFeedbackStatusDB.Approved:
        return <Tag severity={'success'} value={'אושר'} />;
      case DocFeedbackStatusDB.Init:
        return <Tag severity={'warning'} value={'ממתין לתגובה'} />;
      case DocFeedbackStatusDB.Reject:
        return <Tag severity={'danger'} value={'נדחה, ממתין לתגובה'} />;
    }
  };

  const handleDocClick = (doc: DocDetails) => {
    setSelectedDoc(doc);
    setShowFeedbackDialog(true);
  };

  const updateDocFeedbackOperation = async (
    userId: number,
    user: UserSummaryType,
    dockId: number,
    feedbackId: number,
    status: DocFeedbackStatusDB,
    setDocs: (docs: DocDetails[]) => any,
    setLoading: (loading: boolean) => any,
  ) => {
    await updateDocFeedbackHomescreenOperation(
      userId,
      user,
      dockId,
      feedbackId,
      status,
      setDocs,
      () => {
        onUpdate();
        setShowFeedbackDialog(false);
      },
      setLoading,
    );
  };

  return (
    <div
      style={{
        backgroundColor: '#ffffff',
        padding: '20px',
        height: '100%',
        borderRadius: '12px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginBottom: '5px',
        }}
      >
        <div
          style={{ paddingBottom: '10px', color: '#185FD3', fontSize: '18px' }}
        >
          מסמכים שממתינים לאישור ({waitingDocs.length})
        </div>
        {/*<ExportButton
          onClick={() => {
            // TODO
          }}
        />*/}
      </div>
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        value={waitingDocs}
        scrollHeight="200px"
        scrollable
        onRowClick={(e) => handleDocClick(e.data as DocDetails)}
        dataKey="docMetadata.id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
        rowHover
        style={{ cursor: 'pointer' }}
      >
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="docName"
          header="שם מסמך"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: DocDetails) => (
            <div>{rowData.docMetadata.docName}</div>
          )}
        />
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="createdBy"
          header="נוצר ע״י"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: DocDetails) => (
            <div>{rowData.docMetadata.createdByName}</div>
          )}
        />
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="createdAt"
          header="נוצר ב"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: DocDetails) => (
            <div>
              {dateUtils.displayFormatDate(rowData.docMetadata.createdAt)}
            </div>
          )}
        />
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="status"
          header="סטטוס"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: DocDetails) => {
            const status =
              rowData.feedbacks.length > 0
                ? rowData.feedbacks[rowData.feedbacks.length - 1].status
                : DocFeedbackStatusDB.Init;
            return getTag(status);
          }}
        />
      </DataTable>

      {/* Dialog for showing document feedback thread */}
      <Dialog
        header={`מסמך: ${selectedDoc?.docMetadata.docName || ''}`}
        visible={showFeedbackDialog}
        onHide={() => {
          setShowFeedbackDialog(false);
          setSelectedDoc(null);
          setAddFeedbackIndex(null);
        }}
        style={{
          width: '80vw',
          maxWidth: '800px',
          backgroundColor: 'white',
          borderRadius: '8px',
        }}
        maximizable
      >
        {selectedDoc && (
          <div style={{ width: '100%' }}>
            <div style={{ marginBottom: '20px', direction: 'rtl' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                פרטי המסמך:
              </div>
              <div>שם המסמך: {selectedDoc.docMetadata.docName}</div>
              {selectedDoc.docMetadata.docDescription && (
                <div>תיאור: {selectedDoc.docMetadata.docDescription}</div>
              )}
              <div>
                נוצר ב:{' '}
                {dateUtils.displayFormatDate(selectedDoc.docMetadata.createdAt)}
              </div>
              <div>נוצר על ידי: {selectedDoc.docMetadata.createdByName}</div>
            </div>

            <Accordion
              style={{ direction: 'ltr', width: '100%' }}
              expandIcon={(options) => (
                <FaChevronDown
                  style={{
                    transform: options.isActive
                      ? 'rotate(0deg)'
                      : 'rotate(90deg)',
                    transition: 'transform 0.3s',
                    marginLeft: '8px',
                  }}
                />
              )}
              collapseIcon={(options) => (
                <FaChevronDown
                  style={{
                    transform: options.isActive
                      ? 'rotate(90deg)'
                      : 'rotate(0deg)',
                    transition: 'transform 0.3s',
                    marginLeft: '8px',
                  }}
                />
              )}
            >
              <AccordionTab
                headerStyle={{ direction: 'rtl' }}
                style={{ direction: 'rtl' }}
                headerTemplate={() => (
                  <div style={{ direction: 'rtl' }}>
                    <div>היסטוריית תגובות</div>
                    <div style={{ fontWeight: 'normal' }}>
                      {selectedDoc.feedbacks.length
                        ? `(${selectedDoc.feedbacks.length} תגובות)`
                        : 'אין תגובות'}
                    </div>
                  </div>
                )}
                header="היסטוריית תגובות"
              >
                {selectedDoc.feedbacks.map((feedBackItem, index) => (
                  <DocFeedbackItem
                    key={feedBackItem.id}
                    feedback={feedBackItem}
                    userId={selectedDoc.docMetadata.userId}
                    user={null as any} // We might need to get user info
                    index={index + 1}
                    isLast={index === selectedDoc.feedbacks.length - 1}
                    isRejectItem={false}
                    setDocs={setLocalDocs}
                    updateDocFeedbackOperation={updateDocFeedbackOperation}
                    isAdminModeActive={true}
                  />
                ))}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'left',
                    marginTop: '16px',
                  }}
                >
                  <Button
                    label={'הוספת תגובה +'}
                    style={{
                      height: '30px',
                      display: 'flex',
                      justifyContent: 'left',
                    }}
                    severity={'secondary'}
                    outlined={true}
                    onClick={() => setAddFeedbackIndex(0)}
                  />
                </div>

                <Dialog
                  header="הוספת תגובה למסמך"
                  visible={addFeedbackIndex === 0}
                  onHide={() => setAddFeedbackIndex(null)}
                  style={{
                    width: '500px',
                    backgroundColor: 'white',
                    borderRadius: '8px',
                  }}
                >
                  <AddNewDocFeedback
                    userId={selectedDoc.docMetadata.userId}
                    docId={selectedDoc.docMetadata.id}
                  />
                </Dialog>
              </AccordionTab>
            </Accordion>
          </div>
        )}
      </Dialog>
    </div>
  );
};

export default WaitingDocs;
